<template>
    <div class="content-box">
        <h3 class="text-color-error font12px mb10">计划维度托管，仅支持计划下只有一个未删除的产品，以下计划包含多个投放产品：</h3>
        <div class="list-wrap font12px">
            <div class="mb10" v-for="account in data" :key="account.account_id">
                <p>账户ID：{{account.account_id}}；账户名称：{{account.account_name}}</p>
                <div class="ml20 plan-list">
                    <div v-for="plan in account.plan_list||[]" :key="plan.plan_id">
                        <p>计划ID：{{plan.plan_id}}；计划名称：{{plan.plan_name}}</p>
                        <div class="ml20 app-list">
                            <p v-for="app in plan.app_list||[]" :key="app">
                                产品名称：{{app}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="default" @click="hideModal" class="action-btn mr20">关闭</el-button>
        </p>
    </div>
</template>

<script>
    export default {
        name: "DetailInfoModal",
        props:{
            data:Object,
        },
        data(){
            return {
            };
        },
        methods:{
            hideModal(){
                this.$emit('close');
            },
        },
    }
</script>

<style lang="scss" scoped>
    .list-wrap{
        padding-left: 6px;
        max-height: 300px;
        overflow-y: auto;
    }
</style>
